import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[megaStoreAdminNumbersOnlydecimalInput]'
})
export class DecimalInputDirective {
  constructor(private _el: ElementRef) {}

  @HostListener('input', ['$event']) onInputChange(event: any): void {
    const initialValue: string = this._el.nativeElement.value;

    // Remove any characters that are not digits or a decimal point
    let cleanedValue: string = initialValue.replace(/[^0-9.]/g, '');

    // If there's more than one decimal point, remove all but the first one
    const decimalPointIndex: number = cleanedValue.indexOf('.');
    if (decimalPointIndex !== -1) {
      cleanedValue =
        cleanedValue.slice(0, decimalPointIndex + 1) +
        cleanedValue.slice(decimalPointIndex + 1).replace('.', '');
    }

    // Limit to two decimal places
    const decimalParts: string[] = cleanedValue.split('.');
    if (decimalParts.length > 1) {
      cleanedValue = `${decimalParts[0]}.${decimalParts[1].slice(0, 2)}`;
    }

    // Set the cleaned value back to the input element
    this._el.nativeElement.value = cleanedValue;

    // Stop the event propagation if the value has changed
    if (initialValue !== this._el.nativeElement.value) {
      event.stopPropagation();
    }
  }
}
